import { TagProps } from "@lbc-toolkit/tag";
import { Box, Divider } from "@mui/material";
import { SelectItem } from "components/molecules/MultiSelectFreeSolo";
import SidebarDrawer from "components/organisms/SidebarDrawer";
import PLButton from "components/patternLib/PLButton";
import getTestIDs from "lib/utils/getTestIDs";
import React from "react";
import translations from "translations";
import { FooterButtonsContainerSC, FooterButtonsSC, footerDividerStyles, TagModalContentSC } from "./styles";
import TagsInput from "./TagsInput";
import TagsList from "./TagsList";
import Toast from "components/atomics/Toast";

export const testIDs = getTestIDs();

export interface SidebarTagProps extends TagProps {
  id?: string;
  isNewMapped?: boolean;
}

export interface TagsSidebarProps {
  disabled?: boolean;
  error?: string;
  handleAddTag: (tag: SidebarTagProps) => void;
  handleCancel: () => void;
  handleCloseToast: () => void;
  handleCreateTag: (tag: string) => void;
  handleDeleteTag?: (item: SidebarTagProps) => void;
  handleSave: () => void;
  loading?: boolean;
  open?: boolean;
  options: SelectItem[];
  selectedTags: SidebarTagProps[];
  title: string;
}

const {
  globals: {
    button: { save, cancel },
  },
} = translations;

const TagsSidebar: React.FC<TagsSidebarProps> = ({
  handleCancel,
  handleSave,
  open,
  selectedTags,
  handleDeleteTag,
  handleAddTag,
  disabled,
  handleCreateTag,
  options,
  loading,
  title,
  error,
  handleCloseToast,
}) => {
  const footerButtons = (
    <Box>
      <Divider color="#000" sx={footerDividerStyles} />
      <FooterButtonsContainerSC>
        <FooterButtonsSC>
          <PLButton disabled={loading} type="secondary" label={cancel} onClick={handleCancel} />
          <PLButton
            disabled={loading}
            style={{ marginLeft: "30px" }}
            type="primary"
            label={save}
            onClick={handleSave}
          />
        </FooterButtonsSC>
      </FooterButtonsContainerSC>
    </Box>
  );

  return (
    <SidebarDrawer
      title={title}
      loading={loading}
      open={open ?? false}
      onClose={handleCancel}
      maxWidth="22vw"
      footerContent={footerButtons}
    >
      <TagModalContentSC>
        <TagsList selectedTags={selectedTags} handleDeleteTag={handleDeleteTag} loading={loading} />
        <Divider variant="fullWidth" color="#F0F3F6" />
        <TagsInput
          disabled={disabled}
          handleAddTag={handleAddTag}
          handleCreateTag={handleCreateTag}
          label={translations.globals.helpText.createOrSelectTags}
          selectedTags={selectedTags}
          tagOptions={options}
        />
        {error && (
          <Toast open={!loading && !!error} message={error} handleCloseToast={handleCloseToast} severity="error" />
        )}
      </TagModalContentSC>
    </SidebarDrawer>
  );
};

export default TagsSidebar;
